<template>
    <div class="device-type-manange relative">
        <div class="buttons" :style="{position:button_position}">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
<!--            <el-button :id="'doctorAdd'" @click="addAssistant">新增</el-button>-->
            <el-dropdown style="margin-left: 10px">
                <el-button type="primary">
                    导出档案<i class="el-icon-arrow-down el-icon--right" style="line-height: 0;"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" class="export_file">
                    <el-dropdown-item @click.native="getExpertInfo('pdf')">导出pdf文件</el-dropdown-item>
                    <el-dropdown-item @click.native="getExpertInfo('png')">导出png图片</el-dropdown-item>
                    <el-dropdown-item @click.native="sendToMail('pdf', 1)">导出pdf到邮箱</el-dropdown-item>
                    <el-dropdown-item @click.native="sendToMail('png', 1)">导出png到邮箱</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="5" :xl="6" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">特属服务对象姓名：</span>
                <el-input v-model="user_name" id="user_name" placeholder="特属服务对象姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="5" :xl="6" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">特属专家姓名：</span>
                <el-input v-model="doctor_name" id="doctor_name" placeholder="特属专家姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="5" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">档案标题：</span>
                <el-input v-model="title" id="title" placeholder="档案标题模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="5" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">单位：</span>
                <el-input v-model="consultation_hospital" id="consultation_hospital" placeholder="单位模糊搜索"/>
            </el-col>
        </el-row>
        <!-- 表单结束 -->

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
<!--            <el-table-column prop="user_id" label="ID" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="60" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="title" label="档案标题" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="doctor" label="特属专家" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="dispose_str" label="处置方式" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="user_name" label="特属服务对象" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="hospital" label="单位" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="department" label="科室" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column width="100" prop="meet_date" label="会面日期" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="60" prop="image_number" label="图片" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="160" prop="update_date" label="更新时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="160" prop="create_date" label="创建时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                width="80"
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="goDetail(scope.row)"
                           type="text" size="mini">详情
                </el-button>
<!--                <el-button :id="'doctorEdit'" @click="deleteHealthrecords(scope.row)"-->
<!--                           type="text" size="mini">删除-->
<!--                </el-button>-->
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
                v-if="is_pagination_show"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {authUrlCheck, isMobile} from "@/api/order";
    import {getUserInfos} from "@/utils/userInfos";

    export default {
        data() {
            return {
                role_id: 0,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                user_name: '',
                doctor_name: '',
                consultation_hospital: '',
                e_mail: '',
                title:'',
                is_submit: false,
                is_pagination_show: true,
                button_position: 'absolute'
            };
        },
        created(){
            if (isMobile()) {
                this.button_position = 'static'
            }
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
            }
            let q_user_name = this.$route.query.user_name || this.$route.params.user_name;
            this.user_name = q_user_name;
            let prev_page = localStorage.getItem('prev_page');
            if (prev_page == 'health_detail') {
                this.user_name = localStorage.getItem('health_list_user_name')
                this.doctor_name = localStorage.getItem('health_list_doctor_name')
                this.title = localStorage.getItem('health_list_title')
                this.consultation_hospital = localStorage.getItem('health_list_consultation_hospital')
                this.page = parseInt(localStorage.getItem('page'))||1
                this.perpage = parseInt(localStorage.getItem('perpage'))||10
                localStorage.setItem('prev_page', 'health_list')
                if (this.user_name == 'undefined' || this.user_name == 'null') {
                    this.user_name = ''
                }
                if (this.doctor_name == 'undefined' || this.doctor_name == 'null') {
                    this.doctor_name = ''
                }
                if (this.title == 'undefined' || this.title == 'null') {
                    this.title = ''
                }
                if (this.consultation_hospital == 'undefined' || this.consultation_hospital == 'null') {
                    this.consultation_hospital = ''
                }
                this.is_pagination_show = false;
            }
            // 获取档案列表
            this.getList();

        },
        mounted() {

        },
        methods: {
            // 获取所有特属专家
            getList() {

                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'userHealthrecordsListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_name: this.user_name,
                        doctor_name: this.doctor_name,
                        title: this.title,
                        consultation_hospital: this.consultation_hospital,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        // 以序号代替ID
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        var image_number = 0;
                        if (res.data.data.list[i].images) {
                            image_number = (res.data.data.list[i].images.split(',')).length;
                        }
                        res.data.data.list[i].image_number = image_number;

                        switch (res.data.data.list[i].dispose_type) {
                          case "1":
                            res.data.data.list[i].dispose_str = '用药';
                            break;
                          case "2":
                            res.data.data.list[i].dispose_str = '输液';
                            break;
                          case "3":
                            res.data.data.list[i].dispose_str = '留院观察';
                            break;
                          case "4":
                            res.data.data.list[i].dispose_str = '住院治疗';
                            break;
                          default:
                            res.data.data.list[i].dispose_str = res.data.data.list[i].other_dispose_type;
                            break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;

                    localStorage.setItem('health_list_user_name', this.user_name)
                    localStorage.setItem('health_list_doctor_name', this.doctor_name)
                    localStorage.setItem('health_list_title', this.title)
                    localStorage.setItem('health_list_consultation_hospital', this.consultation_hospital)
                    localStorage.setItem('prev_page', 'health_list')
                    localStorage.setItem('page', this.page)
                    localStorage.setItem('perpage', this.perpage)
                    this.is_pagination_show = true
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.user_name = "";
                this.doctor_name = "";
                this.consultation_hospital = "";
                this.title = ""
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.page = 1;
                this.getList();
            },

            goDetail(data) {
                this.$router.push({
                    name: "healthrecordsDetail", params: {
                        id: data.id,
                        user_id: data.user_id,
                        describe: data.describe,
                        title: data.title,
                        doctor_name: data.doctor,
                        consultation_hospital: data.consultation_hospital,
                        consultation_department: data.consultation_department,
                        images: data.images,
                        user_name: data.user_name,
                        dispose_type: data.dispose_type,
                        other_dispose_type: data.other_dispose_type,
                        diagnosis: data.diagnosis,
                        meet_date: data.meet_date,
                        create_date: data.create_date,
                        update_date: data.update_date,
                    }
                }).catch(err =>{});
            },

            // 新增档案
            addAssistant() {

                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/user/HealthrecordsAdd', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({name: "healthrecordsAdd", params: {}});
            },

            deleteHealthrecords(data) {
                this.$confirm('确定删除该档案吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminCustomerServices',
                        method: 'deleteUserHealthrecords',
                        params: {
                            id: data.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: "error",
                                message: res.data.msg,
                                duration: 1500,
                            });
                        } else {
                            this.$message({
                                type: "success",
                                message: '删除成功',
                                duration: 1500,
                            });
                        }
                        this.getList();
                    });
                }).catch(() => {
                });
            },
            async getExpertInfo(file_type, is_to_mail = 0) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                if (this.tableData.length < 1) {
                    this.$message({
                        type: "warning",
                        message: '没有可导出的健康档案！',
                        duration: 1500,
                    });
                    return;
                }
                let text = '正在生成导出文件...'
                if (is_to_mail) {
                    text = '正在发送邮件...'
                }
                const loading = this.$loading({
                    lock: true,
                    text: text,
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.is_submit = true;
                let _that = this
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'exportHealtrecord',
                    params: {
                        user_name: this.user_name,
                        doctor_name: this.doctor_name,
                        title: this.title,
                        consultation_hospital: this.consultation_hospital,
                        file_type: file_type,
                        to_mail: is_to_mail,
                        e_mail: this.e_mail,
                    }
                };
                await this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    loading.close()
                    if (!is_to_mail) {
                        _that.$confirm(`<b style="font-size: 16px;">档案已成功生成${file_type}文件, 是否确定下载</b><br />下载链接：<a style="color: #0057fb;" href="${env.IMG_COMMON_URL_PREFIX+ res.data.data.download_file}" download="${res.data.data.file_name}">${env.IMG_COMMON_URL_PREFIX+ res.data.data.download_file}</a>`, '', {
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '确定下载',
                            cancelButtonText: '取消',
                        }).then(() => {
                            _that.downloadPdf(env.IMG_COMMON_URL_PREFIX+ res.data.data.download_file, res.data.data.file_name)
                        }).catch(()=>{});

                    } else {
                        _that.$confirm(`档案已成功生成${file_type}文件并发送到${this.e_mail}邮箱了，请注意查收`, '', {
                            confirmButtonText: '确定',
                        }).catch(()=>{});
                    }
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            downloadPdf(url, fileName){
                var x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = 'blob';
                x.onload=function(e) {
                    var url = window.URL.createObjectURL(x.response)
                    var a = document.createElement('a');
                    a.href = url
                    a.download = fileName;
                    a.click()
                }
                x.send();

            },
            sendToMail(file_type) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                if (this.tableData.length < 1) {
                    this.$message({
                        type: "warning",
                        message: '没有可导出的健康档案！',
                        duration: 1500,
                    });
                    return;
                }
                let _that = this
                this.$prompt('请输入邮箱', '发送健康档案到邮箱', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                    inputErrorMessage: '邮箱格式不正确'
                }).then(({ value }) => {
                    this.e_mail = value
                    this.getExpertInfo(file_type, 1)
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }).catch(() => {
                    _that.is_submit = false;
                }).finally(() => {
                    _that.is_submit = false;
                });
            }
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .el-dropdown-menu.el-popper.export_file{
        transform:translateY(0) !important;
    }
</style>
